import React, { FC } from "react";
import { Box, Typography } from "@mui/material";

interface StepDotsProps {
    step: number;
    total?: number;
}

export const StepDots: FC<StepDotsProps> = ({ step, total = 6 }) => (
    <Box display="flex" alignItems="center" gap="5px">
        <Typography
            sx={{
                fontSize: 11.5,
                color: "var(--text-2)",
                fontWeight: 500,
                letterSpacing: 0.3,
                fontFamily: "CircularStd",
                mr: "6px",
            }}
        >
            STEP {step} OF {total}
        </Typography>
        {Array.from({ length: total }).map((_, i) => (
            <Box
                key={i}
                sx={{
                    width: i === step - 1 ? 18 : 6,
                    height: 6,
                    borderRadius: 99,
                    background: i < step ? "var(--accent)" : "var(--track)",
                    transition: "all .2s",
                    flexShrink: 0,
                }}
            />
        ))}
    </Box>
);
